
import { Component, Prop, Vue } from "vue-property-decorator";
import { TAnswerBlock } from "@/models/questionnaire";

const CLASS_NAMESPACE_QUESTION = "profile-question";
const CLASS_NAMESPACE_ROW = "profile-row";

const ICONS = {
  add: "add",
  chevronUp: "chevron-down-outline",
  chevronDown: "chevron-up-outline",
  pencil: "pencil-sharp",
};

const EVENT_TYPE = "add";

@Component
export default class ProfileRow extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly answerBlocks!: TAnswerBlock[];
  @Prop([String, Boolean]) readonly label: string | undefined;
  @Prop({ type: Boolean, default: false }) readonly showLabel!: boolean;
  @Prop({ type: Boolean, default: false }) readonly isEditable!: boolean;
  @Prop({ type: Number }) readonly stepID: number | undefined;
  @Prop({ type: Boolean, default: false }) readonly isLooped!: boolean;
  @Prop({ type: Boolean, default: false }) readonly hasHistory!: boolean;
  @Prop({ type: Boolean, default: false }) readonly isLastRow!: boolean;
  @Prop({ type: Boolean, default: false }) readonly isPrevious!: boolean;

  icons = ICONS;

  eventType = EVENT_TYPE;

  popup = false;

  isPreviousShown = false;

  // TASK: Need to refactoring in future, because indexes has different types;
  getAliasResult(aliasResult: string): string {
    switch (aliasResult) {
      case "true":
        return "Yes";
      case "false":
        return "No";
      case "<nil>":
      case " ":
      case "":
        return "-";
      default:
        return aliasResult
          .toString()
          .replaceAll(",,", ", ")
          .trim();
    }
  }

  getAnswerValue(answerBlockLength: number, aliasResult: string) {
    return answerBlockLength ? this.getAliasResult(aliasResult) : "-";
  }

  get icon() {
    return this.isPreviousShown ? this.icons.chevronDown : this.icons.chevronUp;
  }

  get loopedAnswerBlocks() {
    const indexes = [...new Set(this.answerBlocks.map((item) => item.loop_index))];

    return indexes.map((index) =>
      this.answerBlocks.filter((answerBlock) => answerBlock.loop_index === index)
    );
  }

  isLastAnswerBlock(index: number) {
    return index === this.loopedAnswerBlocks.length - 1;
  }

  showDivider(index: number) {
    return this.isLooped && !this.isLastAnswerBlock(index);
  }

  isAddButtonShown(index: number) {
    return this.isLooped && this.isLastAnswerBlock(index) && !this.isPrevious;
  }

  isPreviousButtonShown(index: number) {
    return this.hasHistory && this.isLastAnswerBlock(index) && this.isLastRow;
  }

  viewPrevious() {
    this.isPreviousShown = !this.isPreviousShown;

    this.$emit("view-previous");
  }

  async editStep() {
    const { stepID: stepId } = this;

    if (!stepId) return;

    this.$emit("edit", {
      stepId,
    });
  }

  getLabel(answer: TAnswerBlock) {
    return answer?.show_label ? answer?.label : "";
  }

  get questionClasses() {
    const { isEditable } = this;

    return {
      [`${CLASS_NAMESPACE_QUESTION}_editable`]: isEditable,
    };
  }

  get rowClasses() {
    const { isEditable } = this;

    return {
      [`${CLASS_NAMESPACE_ROW}__answers_editable`]: isEditable,
    };
  }

  showProfileRow(condition: string, answerBlocks: TAnswerBlock[]) {
    if (!condition.includes("==") || condition.includes("{")) return true;

    const conditions = condition.includes("||") ? condition.split("||") : [condition];

    return conditions
      .map((condition) => {
        const [conditionAnswerBlockAlias, conditionAnswer] = condition.split("==");

        return !!answerBlocks.find(
          (answerBlock) =>
            answerBlock.answer_block_alias === conditionAnswerBlockAlias.trim() &&
            answerBlock.alias_result === conditionAnswer.trim()
        );
      })
      .includes(true);
  }
}
